import React from "react";

export const renderFeatureBox = (name: string, optimization?: number) => {
	if (!optimization) {
		return <div className="box-secondary">{name}</div>;
	}
	switch (Math.sign(optimization)) {
		case 1:
			return <div className="box-outline-success">{name}</div>;
		case -1:
			return <div className="box-outline-warning">{name}</div>;
		case 0:
			return <div className="box-outline-success">{name}</div>;
		default:
			return <div className="box-secondary">{name}</div>;
	}
};
